module.exports = __webpack_public_path__ + "static/media/2.ffd3d1c9.jpg";